import { http } from "@/lib/http";
export function fetchGuidePages() {
  return http.get("/api/guides-page").then((res) => res.data);
}
export function fetchGuidePage(id) {
  return http.get(`/api/guides-page/${id}`).then((res) => res.data);
}
export function addGuidePage(payload) {
  return http.post("/api/guides-page/add", payload).then((res) => res.data);
}
export function saveGuidePage(payload) {
  return http.post("/api/guides-page/save", payload).then((res) => res.data);
}
export async function deleteGuidePage(id, imageUrl) {
  await http.post("/api/guides-page/delete", { id });
  if (imageUrl) {
    try {
      await http.delete("/api/file/delete", { data: { s3Url: imageUrl } });
    } catch {}
  }
}
export function uploadGuidePageFile(file) {
  const data = new FormData();
  let url;
  if (file.type.includes("image")) {
    url = "/api/image_upload/guides-page";
    data.append("imageFile", file);
  } else if (file.type.includes("video")) {
    url = "/api/video_upload/guides-page";
    data.append("videoFile", file);
  } else {
    url = "/api/file_upload/guides-page";
    data.append("file", file);
  }
  return http
    .post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.imageUrl);
}
